// extracted by mini-css-extract-plugin
module.exports = {"block":"block-10081f","grid":"grid-10081f","item":"item-10081f","block_adapt_spaces":"block_adapt_spaces-10081f"};